module.exports = __webpack_public_path__ + "img/iidokoro_Logo_02.774dceb7.png";